import { format } from "date-fns";

export function outboundStatusVariant(status) {
  if (!status) return "secondary";
  if (status === "COMPLETED") return "success";
  if (status === "CALL_INITIATED_SUCCESS") return "primary";
  if (status === "ABORTED" || status === "CALL_INITIATED_FAILED") return "danger";
  if (status === "RESPONSE_PROCESSING_ERROR") return "warning";
  if (status === "PROCESSING" || status === "SCHEDULED") return "info";
  return "secondary";
}

/** API may send ISO string or epoch ms (see ai_call_log_frontend_api_contract.md). */
export function formatAiCallLogInstant(value) {
  if (value == null || value === "") return "—";
  const d = typeof value === "number" ? new Date(value) : new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : format(d, "yyyy-MM-dd HH:mm:ss");
}
